import { useSearchParams } from 'wouter';
import { useSearchParam } from '@/shared/react';

export const useConvertParams = (lockedCoin?: string) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [rawType, setType] = useSearchParam('type');
  const type = rawType === 'sell' ? 'sell' : 'buy';
  const coin = searchParams.get('coin')?.toUpperCase() || lockedCoin || 'BTC';
  const peerCoin = searchParams.get('peer')?.toUpperCase() || 'IQD';

  if (coin === peerCoin) throw new Error('Trading Coins Cannot be Equal!');

  return {
    type,
    setType,
    fromCoin: type === 'buy' ? peerCoin : coin,
    setFromCoin: (newValue?: string) => {
      const target = type === 'buy' ? 'peer' : 'coin';
      const peerValue = type === 'buy' ? coin : peerCoin;
      setSearchParams((s) => {
        s.set(target, newValue || '');
        if (peerValue === newValue || !peerValue) {
          s.set(
            target === 'coin' ? 'peer' : 'coin',
            newValue === 'USDT' ? (type === 'buy' ? 'BTC' : 'IQD') : 'USDT',
          );
        }
        return s;
      });
    },
    toCoin: type === 'buy' ? coin : peerCoin,
    setToCoin: (newValue?: string) => {
      const target = type === 'sell' ? 'peer' : 'coin';
      const peerValue = type === 'sell' ? coin : peerCoin;
      setSearchParams((s) => {
        s.set(target, newValue || '');
        if (peerValue === newValue || !peerValue) {
          s.set(
            target === 'coin' ? 'peer' : 'coin',
            newValue === 'USDT' ? (type === 'sell' ? 'BTC' : 'IQD') : 'USDT',
          );
        }
        return s;
      });
    },
  } as const;
};
